/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingPlayerClaim
 */
export interface TrainingPlayerClaim {
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayerClaim
     */
    assignmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayerClaim
     */
    trainingId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayerClaim
     */
    trainingName?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayerClaim
     */
    playerId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayerClaim
     */
    playerName?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayerClaim
     */
    claimedEmail?: string;
    /**
     * 
     * @type {Date}
     * @memberof TrainingPlayerClaim
     */
    claimedAt?: Date;
}

/**
 * Check if a given object implements the TrainingPlayerClaim interface.
 */
export function instanceOfTrainingPlayerClaim(value: object): value is TrainingPlayerClaim {
    return true;
}

export function TrainingPlayerClaimFromJSON(json: any): TrainingPlayerClaim {
    return TrainingPlayerClaimFromJSONTyped(json, false);
}

export function TrainingPlayerClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingPlayerClaim {
    if (json == null) {
        return json;
    }
    return {
        
        'assignmentId': json['assignmentId'] == null ? undefined : json['assignmentId'],
        'trainingId': json['trainingId'] == null ? undefined : json['trainingId'],
        'trainingName': json['trainingName'] == null ? undefined : json['trainingName'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'claimedEmail': json['claimedEmail'] == null ? undefined : json['claimedEmail'],
        'claimedAt': json['claimedAt'] == null ? undefined : (new Date(json['claimedAt'])),
    };
}

export function TrainingPlayerClaimToJSON(json: any): TrainingPlayerClaim {
    return TrainingPlayerClaimToJSONTyped(json, false);
}

export function TrainingPlayerClaimToJSONTyped(value?: TrainingPlayerClaim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignmentId': value['assignmentId'],
        'trainingId': value['trainingId'],
        'trainingName': value['trainingName'],
        'playerId': value['playerId'],
        'playerName': value['playerName'],
        'claimedEmail': value['claimedEmail'],
        'claimedAt': value['claimedAt'] == null ? value['claimedAt'] : value['claimedAt'].toISOString(),
    };
}

